import { Card, CardHeader } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import ConnectionsPeriodChart from "./ConnectionsByMonthChart";

// ----------------------------------------------------------------------

export const ConnectionsByMonthCard = () => {
	const { translate } = useLocales();

	return (
		<Card sx={{ pb: 2 }}>
			<CardHeader title={translate("overview.total_connections_by_month")} />
			<ConnectionsPeriodChart />
		</Card>
	);
};

export default ConnectionsByMonthCard;
